import { makeAutoObservable } from "mobx";

export const DepartmentCodes = {
	Prologue: 'Prologue',
	Finance: 'Finance',
	DistributionServices: 'DS',
} as const;

export type DepartmentCode = typeof DepartmentCodes[keyof typeof DepartmentCodes] | string;

export interface Department {
	id: number;
	code: DepartmentCode;
	name: string;
	defaultDomain?: string;
	netSuiteAccount?: string;
	isActive: boolean;
	domains?: DepartmentDomain[];
}

export interface AdminDepartment extends Department {
	defaultDomain: string;
	netSuiteAccount: string;
}

export class DepartmentModel implements AdminDepartment {
	readonly id: number;
	code: DepartmentCode;
	name: string;
	defaultDomain: string;
	netSuiteAccount: string;
	isActive: boolean;

	constructor(department: AdminDepartment) {
		makeAutoObservable(this);
		this.id = department.id;
		this.code = department.code;
		this.name = department.name;
		this.defaultDomain = department.defaultDomain;
		this.netSuiteAccount = department.netSuiteAccount;
		this.isActive = department.isActive ?? true;
	}

	get canSave() {
		return Boolean(
			this.code.trim()
			&& this.name.trim()
			&& this.defaultDomain.trim()
			&& this.netSuiteAccount.trim()
		);
	}

	setField<K extends keyof DepartmentModel>(field: K, value: DepartmentModel[K]) {
		(this[field] as DepartmentModel[K]) = value;
	}
}

export interface DepartmentDomain {
	id: number;
	departmentId: number;
	hostName: string;
	isPrimary: boolean;
	isActive: boolean;
}

export interface UserDepartment {
	userId: string;
	departmentId: number;
	isDefault: boolean;
	isActive: boolean;
	department?: Department;
}

export interface CurrentDepartmentResponse {
	activeDepartmentId: number;
	allowedDepartments: Department[];
}

export const findDepartmentById = (departmentId: number, departments: Department[]) =>
	departments.find(department => department.id === departmentId);
